export default __webpack_public_path__ + "static/media/aboutBG.21d859a7.jpg";